import Immutable from 'seamless-immutable';

const initialState = Immutable({
  showModal: false,
  openSidebar: true,
});

export default initialState;
